'use strict';

module.exports = function (obj) {

  if (obj == null) {
    return false;
  }

  var o = Object(obj);

  return o === o.window;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-window/index.js
// module id = 344
// module chunks = 0 1